<template>
    <card :icon="['fab', 'google']"
          v-if="hasLoaded"
          :headline="$t('conversions.gmb.gmb')"
          :description="$t('conversions.notInGraph')">
        <div class="table-wrapper table-selectable table-column-even">
            <div class="table-header">
                <div class="col-lg-10 col-md-12 table-column header-border table-header-title">
                    <h6>{{$t('conversions.gmb.metric')}}</h6>
                </div>

                <div class="col-lg-2 hidden-md hidden-sm hidden-xs">
                    <div class="row">
                        <div class="col-lg-12 table-column insight-explainer-icon">
                            <i>
                                <fa icon="asterisk"/>
                            </i>
                            <small class="table-header__text">{{$t('conversions.gmb.total')}}</small>
                        </div>
                    </div>
                </div>
            </div>

            <div class="table-body">
                <div class="col-lg-12 table-row" v-for="(value, metric) in values">
                    <div class="row">
                        <div class="col-lg-10 table-column campaign-name header-border hidden visible-lg">
                            {{$t(`conversions.gmb.${metric}`)}}
                        </div>

                        <!-- DESKTOP -->
                        <div class="col-lg-2 table-column insight-value text-center hidden visible-lg">
                            <small>{{value}}</small>
                        </div>

                        <!-- MOBILE -->
                        <div class="col-sm-12 col-xs-12 col-md-12 hidden-lg">
                            <div class="row mobile-container">
                                <div class="col-md-4 col-sm-4 col-xs-6 table-column insight-explainer-icon">
                                    <small class="table-header__text">
                                        {{$t(`conversions.gmb.${metric}`)}}
                                    </small>
                                </div>

                                <div class="col-md-8 col-sm-8 col-xs-6 table-column insight-value text-center">
                                    {{value}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </card>
</template>

<style lang="scss" scoped>
    @import '~@/assets/scss/_table.scss';
</style>

<script>
  import * as LocationService from '@/services/google/LocationService'
  import hasIntegration from '@/mixins/integrations/hasIntegration'
  import datepickerMixin from '@/app/datepicker/datepicker.mixin'
  import moment from 'moment'

  export default {
    mixins: [hasIntegration, datepickerMixin],

    data () {
      return {
        location: null,
        values: {}
      }
    },

    mounted () {
      this.load()
    },

    computed: {
      locationId () {
        if (!this.location) {
          return
        }

        const location = this.location

        return location.name.split('/').pop()
      },

      hasLoaded () {
        return Object.values(this.values).length > 0
      }
    },

    methods: {
      load () {
        if (!this.hasIntegration('Google MyBusiness')) {
          return
        }

        LocationService.location({}, response => {
          this.location = response.data

          this.loadResults(results => {
            this.values = results
          })
        }, () => {})
      },

      loadResults (cb) {
        this.values = {}

        const end = moment(this.to)
        const now = moment()

        if (end.format('YYYY-MM-DD') >= now.format('YYYY-MM-DD')) {
          end.subtract(1, 'day')
        }

        const data = {
          startTime: this.from.toISOString(),
          endTime: end.toISOString()
        }

        LocationService.insights(this.locationId, data, response => {
          const results = this.parseValues(response.data)

          cb(results)
        })
      },

      parseValues (response) {
        const values = {
          viewsInSearch: 0,
          websiteClicks: 0,
          phoneClicks: 0,
          viewsInMaps: 0,
          drivingDirections: 0
        }

        if (!response.locationMetrics || !response.locationMetrics[0]) {
          return values
        }

        const metrics = response.locationMetrics[0]

        if (!metrics.metricValues) {
          return values
        }

        const metricValues = metrics.metricValues

        metricValues.forEach(element => {
          if (!element.metric || !element.totalValue) {
            return
          }

          const totalValue = element.totalValue

          switch (element.metric) {
            case 'VIEWS_SEARCH':
              values.viewsInSearch = parseInt(totalValue.value)
              break

            case 'ACTIONS_WEBSITE':
              values.websiteClicks = parseInt(totalValue.value)
              break

            case 'ACTIONS_PHONE':
              values.phoneClicks = parseInt(totalValue.value)
              break

            case 'VIEWS_MAPS':
              values.viewsInMaps = parseInt(totalValue.value)
              break

            case 'ACTIONS_DRIVING_DIRECTIONS':
              values.drivingDirections = parseInt(totalValue.value)
              break
          }
        })

        return values
      }
    }
  }
</script>
